/*
 * CRO mobile-conversion (2026-07): PDP variant image swap.
 *
 * Problem: selecting a color updates the variant + URL but the product image
 * does NOT change (confirmed on live + dev). The theme HAS swap logic
 * (updateProductImage -> flickity.select of the variant's media slide) but it
 * is not being triggered on color change, so multi-color shoes (Vengeance,
 * Flyte, ...) freeze on the first image -> "variant thrash" -> mobile bail.
 *
 * Fix: a scoped enhancement that supplies the missing trigger. On variant
 * change we read the resolved variant id, look up its featured_media.id in the
 * embedded product JSON, and drive the theme's own mobile Flickity carousel to
 * that slide. Idempotent (no-op if the slide is already selected) so it never
 * fights a working native swap, and gated to the active mobile carousel so it
 * never touches the desktop stacked gallery.
 */
(function () {
  'use strict';

  function readProduct(scope) {
    var scripts = scope.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var json = JSON.parse(scripts[i].textContent);
        if (json && json.variants && json.variants.length) return json;
      } catch (e) {}
    }
    return null;
  }

  function init(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var gallery = root.querySelector('.product-gallery');
    if (!form || !gallery) return;
    var slider = gallery.querySelector('.product-gallery__media-slider');
    if (!slider) return;

    var product = readProduct(root);
    if (!product) return;

    // variant id -> featured_media id
    var featuredBy = {};
    product.variants.forEach(function (v) {
      if (v && v.featured_media && v.featured_media.id != null) {
        featuredBy[String(v.id)] = String(v.featured_media.id);
      }
    });

    function currentVariantId() {
      var input = form.querySelector('[name="id"]');
      if (input && input.value) return input.value;
      var m = location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }

    function swapTo(mediaId) {
      if (!mediaId) return;
      var flkty;
      try {
        flkty = window.theme && window.theme.Flickity && window.theme.Flickity.data(slider);
      } catch (e) {}
      // Only drive the active mobile carousel; leave the desktop stacked gallery alone.
      if (!flkty || !flkty.isActive || typeof flkty.select !== 'function') return;

      var slide = slider.querySelector('.product-gallery__media-slide[data-id="' + mediaId + '"]');
      if (!slide || slide.classList.contains('is-selected')) return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.product-gallery__media-slide'));
      var index = slides.indexOf(slide);
      if (index > -1) flkty.select(index);
    }

    var last = currentVariantId();
    function update() {
      var id = currentVariantId();
      if (!id || id === last) return;
      last = id;
      swapTo(featuredBy[id]);
    }

    // The theme resolves [name="id"] on variant change; defer so we read the
    // updated value, then retry once in case it resolves a beat later.
    function scheduleUpdate() {
      window.setTimeout(update, 80);
      window.setTimeout(update, 300);
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.type === 'radio' || t.tagName === 'SELECT')) scheduleUpdate();
    });
    // Some themes dispatch their own variant-change event; catch it too.
    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('theme:variant:change', scheduleUpdate);
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the theme editor when the product section reloads.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
